module.exports = __webpack_public_path__ + "img/portrait-026.6b4fdb3e.jpg";